/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingMetrics } from '../models/ListingMetrics';
import type { ListingMetrics_ListingMetricsUpdate_metrics_read } from '../models/ListingMetrics_ListingMetricsUpdate_metrics_read';
import type { ListingMetrics_ListingMetricsUpdate_metrics_write } from '../models/ListingMetrics_ListingMetricsUpdate_metrics_write';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingMetricsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ListingMetrics resource.
     * Retrieves a ListingMetrics resource.
     * @param listingType ListingMetrics identifier
     * @param listingId ListingMetrics identifier
     * @returns ListingMetrics ListingMetrics resource
     * @throws ApiError
     */
    public apiAccommodationslistingmetricsListingTypeListingIdGet(
        listingType: string,
        listingId: string,
    ): CancelablePromise<ListingMetrics> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/metrics/{listingType}/{listingId}',
            path: {
                listingType: listingType,
                listingId: listingId,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Updates the ListingMetrics resource.
     * Updates the ListingMetrics resource.
     * @param listingType ListingMetrics identifier
     * @param listingId ListingMetrics identifier
     * @param requestBody The updated ListingMetrics resource
     * @returns ListingMetrics_ListingMetricsUpdate_metrics_read ListingMetrics resource updated
     * @throws ApiError
     */
    public apiListingsmetricsListingTypeListingIdPatch(
        listingType: string,
        listingId: string,
        requestBody: ListingMetrics_ListingMetricsUpdate_metrics_write,
    ): CancelablePromise<ListingMetrics_ListingMetricsUpdate_metrics_read> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/listings/metrics/{listingType}/{listingId}',
            path: {
                listingType: listingType,
                listingId: listingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                404: `Resource not found`,
                422: `Unprocessable entity`,
            },
        });
    }
}
